import { render, staticRenderFns } from "./SharesTotal.vue?vue&type=template&id=0ee75e80&"
import script from "./SharesTotal.vue?vue&type=script&lang=js&"
export * from "./SharesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports